import type { GetRuntimeManifest } from "@skilitics/nautilus-core-designer-data";

import type { GetManifestByTypeId } from "../types/index.ts";

interface Options {
  getManifest: GetManifestByTypeId;
}

export const getRuntimeManifestCreate =
  ({ getManifest }: Options): GetRuntimeManifest =>
  (typeId: string) =>
    getManifest(typeId).terminus;
